import axios from 'axios';
import _orderBy from 'lodash.orderby';
import Vue from 'vue';
import Errors from '../classes/errors';
import { setCaptchaEuScript } from '../utils';

Vue.component('enterprise-form-component', {
    props: {
        siteHandle: {
            value: String,
        },
        stores: {
            value: Object,
        },
        brandstoreResultAmount: {
            value: Number,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            requestType: 'private',
            requestIndex: 0,
            countryHandle: '',
            selectedBrandStore: '',

            dropdownCountry: null,
            dropdownStore: null,

            // Dealer search (zip code vars)
            store: '',
            zipCoords: null,
            searchQueryIsDirty: false,
            nearbyProximityStores: null,
            // Error vars for zip api request
            needMoreInput: false,
            apiRequestLoading: false,
            countryValue: {
                mgMotorsNetherlands: 'NL',
                mgMotorsBelgiumNl: 'BE',
                mgMotorsBelgiumFr: 'BE',
                mgMotorsAustria: 'AT',
                mgMotorsDanmark: 'DK',
                mgMotorsGermany: 'DE',
                mgMotorsSpain: 'ES',
                mgMotorsFrance: 'FR',
                mgMotorsIceland: 'IS',
                mgMotorsItaly: 'IT',
                mgMotorsLuxembourgFr: 'LU',
                mgMotorsNorway: 'NO',
                mgMotorsPortugal: 'PT',
                mgMotorsSweden: 'SE',
                mgMotorsHungary: 'HU',
            },
            fleetType: '',
            fleetTypeValue: '',
            fleetSize: '',
            fleetSizeValue: '',
        };
    },

    computed: {
        moreThenTwoStores: function () {
            if (!this.countryHandle) {
                return false;
            }
            return Object.keys(this.stores).length > 2;
        },
        hasBrandStores: function () {
            if (!this.countryHandle) {
                return false;
            }
            return Object.keys(this.stores).length > 0;
        },
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },
        toggleLoadingButtonClass() {
            return this.submitting ? 'button--loading' : '';
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }
        setCaptchaEuScript();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;
            if (this.submitting) {
                return;
            }

            this.submitting = true;
            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },
        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);
                const result = response.data;
                if (result.data.errors) {
                    this.submitting = false;
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    // this.scrollToFirstError();
                    return;
                }
                this.errors.clear();
                window.location = this.$refs.redirectUrl.value;
            } catch (e) {
                throw new Error(e);
            }
        },

        toggleDropdown(event) {
            let element = event.currentTarget;
            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },
        setDropdownCustomerType(event) {
            this.fleetType = event.currentTarget.dataset.text;
            this.fleetTypeValue = event.currentTarget.dataset.value;
            this.toggleDropdown(event);
        },
        setDropdownAutomotivePark(event) {
            this.fleetSize = event.currentTarget.dataset.text;
            this.fleetSizeValue = event.currentTarget.dataset.value;
            this.toggleDropdown(event);
        },
    },
});
